// action creators for admin dashboard.

export const getTotalETI = (obj) => ({
  type: "GET_TOTAL_ETI",
  obj,
});

export const getTotalETISuccess = (data) => ({
  type: "GET_TOTAL_ETI_SUCCESS",
  data,
});

export const getTotalETIFail = (error) => ({
  type: "GET_TOTAL_ETI_FAIL",
  error,
});

export const getTotalETO = (obj) => ({
  type: "GET_TOTAL_ETO",
  obj,
});

export const getTotalETOSuccess = (data) => ({
  type: "GET_TOTAL_ETO_SUCCESS",
  data,
});

export const getTotalETOFail = (error) => ({
  type: "GET_TOTAL_ETO_FAIL",
  error,
});

export const getTotalPaidUnpaidPendingTax = (obj) => ({
  type: "GET_TOTAL_PAID_UNPAID_PENDING_TAX",
  obj,
});

export const getTotalPaidUnpaidPendingTaxSuccess = (data) => ({
  type: "GET_TOTAL_PAID_UNPAID_PENDING_TAX_SUCCESS",
  data,
});

export const getTotalPaidUnpaidPendingTaxFail = (error) => ({
  type: "GET_TOTAL_PAID_UNPAID_PENDING_TAX_FAIL",
  error,
});

export const getAdminUsersList = (obj) => ({
  type: "GET_ADMIN_USERS_LIST",
  obj,
});

export const getAdminUsersListSuccess = (data) => ({
  type: "GET_ADMIN_USERS_LIST_SUCCESS",
  data,
});

export const getAdminUsersListFail = (error) => ({
  type: "GET_ADMIN_USERS_LIST_FAIL",
  error,
});


export const getTotalRegisteredPropertiesFiscalYear = (obj) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR",
  obj,
});

export const getTotalRegisteredPropertiesFiscalYearSuccess = (data) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR_SUCCESS",
  data,
});

export const getTotalRegisteredPropertiesFiscalYearFail = (error) => ({
  type: "GET_TOTAL_REGISTERED_PROPERTIES_FISCAL_YEAR_FAIL",
  error,
});
